/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { SearchTextField } from '@components/atoms'
import { motion } from 'framer-motion'

interface PropsType {
	style?: React.CSSProperties
	inputStyle?: React.CSSProperties
	defaultValue?: string
	onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
	maxWidth?: number
	defaultWidth?: number
}

export const MotionSearchTextField = (props: PropsType) => {
	// state
	const [isFocused, setIsFocused] = React.useState(false)

	// variables
	const inputWidth: string = props.maxWidth ? `${props.maxWidth}rem` : '20rem'
	const defaultWidth: string = props.defaultWidth ? `${props.defaultWidth}rem` : '7rem'

	const onFocus = React.useCallback(() => {
		setIsFocused(true)
	}, [])

	const onBlur = React.useCallback(() => {
		setIsFocused(false)
	}, [])

	return (
		<motion.div
			css={[style, { ...props.style }]}
			initial={false}
			animate={isFocused ? { width: inputWidth } : { width: defaultWidth }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.5, type: 'spring' }}
		>
			<SearchTextField
				style={{ ...props.inputStyle }}
				className="searchTextField"
				label=""
				defaultValue={props.defaultValue}
				onChange={props.onSearchChange}
				onFocus={onFocus}
				onBlur={onBlur}
			/>
		</motion.div>
	)
}

const style = css({
	width: '12rem',
	marginBottom: '0.3rem',

	'.searchTextField': {
		width: '100%',

		'& fieldset': {
			borderRadius: '20px',
		},
	},
})
